import dayjs from "@/plugins/dayjs";
// import createUUID from "@/helpers/uuid";
import axios from "axios";
// const URL = "http://192.168.0.105:3001/automations/";
const URL = process.env.VUE_APP_API + "advertisements/system/";

/**
 * Initial state
 */
export const state = {
  notifications: [],
};

/**
 * Mutations
 */
export const mutations = {
  ["SET_NOTIFICATIONS"](state, notifications) {
    state.notifications = notifications;
    // if (notifications.length > 0) {
    //   console.log("state.notifications", state.notifications, notifications);
    // }
  },
  ["SET_NEW"](state, notification) {
    state.notifications.push(notification);
    // if (notifications.length > 0) {
    //   console.log("state.notifications", state.notifications, notifications);
    // }
  },
  ["SET_WATCHED"](state, slug) {
    let newState = [...JSON.parse(JSON.stringify(state.notifications))];
    // newState.map((notification) => {
    //   if (notification.dispatch.advertisement.slug === slug) {
    //     notification.watched_at = dayjs().format("YYYY-MM-DD HH:mm:ss");
    //     // notification.agreed = true;
    //   }
    //   return notification;
    // });
    for (let i = 0; i < newState.length; i++) {
      if (newState[i].dispatch.advertisement.slug == slug) {
        newState[i].watched_at = dayjs().format("YYYY-MM-DD HH:mm:ss");
        newState.splice(i, 1);
      }
    }
    state.notifications = newState;
  },
  ["SET_DISSMISSED"](state, slug) {
    let newState = [...JSON.parse(JSON.stringify(state.notifications))];
    // console.log("state.notifications1", newState);
    // console.log("state.notifications1 array", Object.values(newState));
    for (let i = 0; i < newState.length; i++) {
      if (newState[i].dispatch.advertisement.slug == slug) {
        newState.splice(i, 1);
        break;
      }
    }
    // console.log("state.notifications2", newState);
    // Object.values(newState).map((notification) => {
    //   // if (notification.dispatch_id === id) {
    //   delete notification.dispatch_id === id;
    //   // }
    //   // return notification;
    // });
    //         let newState = [];
    //         newState = [...JSON.parse(JSON.stringify(this.ownNotifications))];
    //         for (let i = 0; i < newState.length; i++) {
    //           if (newState[i].dispatch_id === d_id) {
    //             newState.splice(i, 1);
    //             break;
    //           }
    //         }
    //         this.ownNotifications = newState;
    state.notifications = newState;
  },
};

/**
 * Actions
 */
export const actions = {
  async getNotifications({ commit }) {
    await axios
      .get(URL)
      .then((res) => {
        commit("SET_NOTIFICATIONS", res.data.data);
      })
      .catch((err) => {
        console.log("ERROR IS: ", err);
      });
  },
  async setWatched({ commit }, slug) {
    // uuid = "77dafdd4-a0bf-4aea-9ca8-96d7e1502b54";
    await axios
      .post(URL + `${slug}/watch`)
      .then(() => {
        commit("SET_WATCHED", slug);
      })
      .catch((err) => {
        console.log("ERROR IS: ", err);
      });
  },
  async setDisWatched({ commit }, slug) {
    // uuid = "77dafdd4-a0bf-4aea-9ca8-96d7e1502b54";
    await axios
      .post(URL + `${slug}/watch-disagree`)
      .then(() => {
        commit("SET_WATCHED", slug);
      })
      .catch((err) => {
        console.log("ERROR IS: ", err);
      });
  },
  async dissmiss({ commit }, slug) {
    commit("SET_DISSMISSED", slug);
    // console.log(state.notifications);
  },
  async newUnread({ commit }, notification) {
    commit("SET_NEW", notification);
    // console.log(state.notifications);
  },
};

/**
 * Getters
 */
export const getters = {
  notifications: (state) => state.notifications,
};
